import React from 'react'
import {createRoot} from 'react-dom/client'
import {Provider} from 'react-redux'
import * as Sentry from '@sentry/react'

import App from './App'
import store from './store'

if (!new RegExp(/^dev/).test(process.env.REACT_APP_ENV)) {
  Sentry.init({
    dsn:
      'https://6f626f8950fe656331db4fa99082d320@sentry.florajet.io/5',
    integrations: [],
  })
}

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)
